import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "../components/Loader/Loader.sass"
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader/Loader";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from 'react-device-detect'
import { apiUser } from "../basedata/apiCall";
import InfoModal from "../components/Modal/ModalInfo"
import { useStep } from "../context/StepContext";

const ValidatingOneToMany = () => {

  const { t } = useTranslation(); 
  const [accepted, setAccepted] = useState(false);
  const navigate = useNavigate();
  const { setStep } = useStep();

  const handleAcceptTerms = () => {
    setAccepted(!accepted);
  };

  const handleContinue = () => {
    if (accepted) {
      navigate("/signup");
    }
  }

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [error_message, setError_message] = useState('A sua selfie e a foto do documento não batem.');
  const closeModal = async () => {
    const _temp_token = sessionStorage.getItem('token')
    const _validate_doc = await apiUser.get(`/biometry/onboarding/retry?uid=${_temp_token}`)
    setIsModalOpen(false);
    window.location.href = '/document-handler'
  };

    let counter = 0;
    const getUserFlow = async (userToken:any) => {
      if(counter >= 25){
        window.location.href = 'waiting';
      }
      counter++;
    try {

      const _response:any = await apiUser.post(`/biometry/onboarding/user-jorney/status`, { token: userToken })

      if(!_response?.data){
        return setTimeout(() => {
          getUserFlow(userToken);
        }, 2000);
      }else{
        sessionStorage.setItem('user_document', _response?.data?.userInformation?.document || 'na')
        sessionStorage.setItem('name', _response?.data?.userInformation?.name || 'na')
      }

      if (_response.data.message === 'error_doppelganger_found') {
       return  window.location.href = 'waiting';
      } else if (_response.data.message === 'biometry_not_found' && counter > 4) {
        return window.location.href = 'instructions';
      } else if (_response.data.message === 'user_not_found') {
        return window.location.href = 'signup';
      } 
        
      if (_response.data.message === 'done') {
        return window.location.href = 'success';
      }else if (_response.data.message === 'document_front') {
        return window.location.href = 'instructions-document';
      }

      return setTimeout(() => {
        getUserFlow(userToken);
      }, 2000);

    } catch (e) {
      return setTimeout(() => {
        getUserFlow(userToken);
      }, 2000);
    }
    }


  

  useEffect(() => {

    const params = new URLSearchParams(window.location.search)
    let currentToken = params.get('token'),
    currentCompany = params.get('orc')

    if(currentToken){
      sessionStorage.setItem('token', `${currentToken}`)
      sessionStorage.setItem('originCompany', `${currentCompany}`)
    }else{
    currentToken = sessionStorage.getItem('token')
    currentCompany = sessionStorage.getItem('orc')
    }

    if(!currentToken){
      window.location.href = '/'
    }

    getUserFlow(currentToken);
  }, []);



  return (
      <div className="loader">
        <div className="spinner">
        </div>
      </div>
  );
};

export default ValidatingOneToMany;